import React from 'react'
import './M_Header.css'

export const M_Header = ({ element, color, backgroundColor, notsticky }) => {

    notsticky = notsticky ? false : true
    color = color || 'var(--color-grey)'
    backgroundColor = backgroundColor || 'var(--color-white)'

    return (
        <div className='headerComponent' style={notsticky ? {
            background: backgroundColor, borderBottom: `1px solid ${color}`,
        } : { background: backgroundColor, borderBottom: `1px solid ${color}` }}>
            {element}
        </div >

    )
}